import type { InstallDepsOptions, InstallDepsResult } from '@cli-types/next-adapter/init.js'
import { buildAddArgs } from './build-add-args.js'
import { ensurePnpmAllowedBuilds } from './ensure-pnpm-allowed-builds.js'
import { ensurePnpmPackageExtensions } from './ensure-pnpm-package-extensions.js'
import { ensurePnpmPackageManager } from './ensure-pnpm-package-manager.js'
import { resolveDependencyInstallPlan } from './resolve-dependency-install-plan.js'
import { runDependencyInstall } from './run-dependency-install.js'

export async function installDependenciesAsync({
  cwd,
  pm,
  dependencies,
  devDependencies,
  pnpmAllowedBuilds
}: InstallDepsOptions): Promise<InstallDepsResult> {
  const installPlan = resolveDependencyInstallPlan({
    cwd,
    pm,
    dependencies,
    devDependencies,
    pnpmAllowedBuilds
  })

  try {
    if (pm === 'pnpm') {
      ensurePnpmPackageManager(cwd)
      ensurePnpmAllowedBuilds(cwd, installPlan.pnpmAllowedBuilds ?? [])
      ensurePnpmPackageExtensions(cwd, installPlan.dependencies)
    }

    const pnpmStoreRecovery = { attempted: false }

    if (installPlan.dependencies.length > 0) {
      await runDependencyInstall(
        pm,
        buildAddArgs(pm, installPlan.dependencies, false),
        cwd,
        pnpmStoreRecovery
      )
    }

    if (installPlan.devDependencies.length > 0) {
      await runDependencyInstall(
        pm,
        buildAddArgs(pm, installPlan.devDependencies, true),
        cwd,
        pnpmStoreRecovery
      )
    }

    return {
      dependencies: installPlan.dependencies,
      devDeps: installPlan.devDependencies,
      success: true,
      error: null
    }
  } catch (err) {
    return {
      dependencies: installPlan.dependencies,
      devDeps: installPlan.devDependencies,
      success: false,
      error: err instanceof Error ? err.message : 'Install failed'
    }
  }
}
